const LocalTranslation = {
  InitialisingRecording: {
    en: `Setting up log tracking for smoother experiences.`,
    "en-GB": `Setting up log tracking for smoother experiences.`,
    "ms-MY": `Mengatur pelacakan log untuk pengalaman yang lebih lancar.`,
    "th-TH": `ตั้งค่าการติดตามการเข้าสู่ระบบเพื่อประสบการณ์ที่ราบรื่นมากขึ้น.`,
    "vi-VN": `Thiết lập theo dõi nhật ký để trải nghiệm mượt mà hơn.`,
    "id-ID": `Mengatur pelacakan log untuk pengalaman yang lebih mulus.`,
    "zh-CN": `正在设置日志跟踪以改善体验。`
  },
  DebugModeDescription: {
    en: `Your logs are currently being sent to aid us in improving your experience.`,
    "en-GB": `Your logs are currently being sent to aid us in improving your experience.`,
    "ms-MY": `Log anda kini sedang dihantar untuk membantu kami dalam meningkatkan pengalaman anda.`,
    "th-TH": `ข้อมูลประวัติการใช้งานของคุณกำลังถูกส่งไปเพื่อช่วยเราปรับปรุงประสบการณ์ของคุณ.`,
    "vi-VN": `Các bản ghi của bạn hiện đang được gửi để hỗ trợ chúng tôi cải thiện trải nghiệm của bạn.`,
    "id-ID": `Log Anda saat ini dikirimkan untuk membantu kami meningkatkan pengalaman Anda.`,
    "zh-CN": `您的日志正在发送，以帮助我们改进您的体验。`
  },
  DebugModeTitle: {
    en: `You are in debug mode.`,
    "en-GB": `You are in debug mode.`,
    "ms-MY": `Anda berada dalam mod debug.`,
    "th-TH": `คุณอยู่ในโหมดดีบัก.`,
    "vi-VN": `Bạn đang ở chế độ debug.`,
    "id-ID": `Anda berada dalam mode debug.`,
    "zh-CN": `您正在调试模式中。`
  },
  DebugIdTitle: {
    en: `Debug ID`,
    "en-GB": `Debug ID`,
    "ms-MY": `ID Debug`,
    "th-TH": `รหัสการดีบัก`,
    "vi-VN": `ID Gỡ lỗi`,
    "id-ID": `ID Debug`,
    "zh-CN": `调试 ID`
  },
  InitialisingDebugModeTitle: {
    en: `Initializing Debug Mode...`,
    "en-GB": `Initialising Debug Mode...`,
    "ms-MY": `Memulakan Mod Debug...`,
    "th-TH": `กำลังเริ่มต้นโหมดดีบัก...`,
    "vi-VN": `Đang khởi tạo Chế độ Gỡ lỗi...`,
    "id-ID": `Menginisialisasi Mode Debug...`,
    "zh-CN": `初始化调试模式...`
  },
  ExitButton: {
    en: `Exit`,
    "en-GB": `Exit`,
    "ms-MY": `Keluar`,
    "th-TH": `ออก`,
    "vi-VN": `Thoát`,
    "id-ID": `Keluar`,
    "zh-CN": `退出`
  },
  ExitDebugModeButton: {
    en: `Exit debug mode`,
    "en-GB": `Exit debug mode`,
    "ms-MY": `Keluar mod debug`,
    "th-TH": `ออกจากโหมดดีบัก`,
    "vi-VN": `Thoát chế độ debug`,
    "id-ID": `Keluar dari mode debug`,
    "zh-CN": `退出调试模式`
  },
  ExitDebugModeSuccessMessage: {
    en: `Successfully exited debug mode. Recording has stopped.`,
    "en-GB": `Successfully exited debug mode. Recording has stopped.`,
    "ms-MY": `Berjaya keluar dari mod debug. Perekaman telah berhenti.`,
    "th-TH": `ออกจากโหมดดีบักเรียบร้อยแล้ว การบันทึกได้หยุดแล้ว`,
    "vi-VN": `Đã thoát thành công khỏi chế độ debug. Việc ghi lại đã dừng lại.`,
    "id-ID": `Berhasil keluar dari mode debug. Perekaman telah berhenti.`,
    "zh-CN": `成功退出调试模式。录制已停止。`
  },
  ExitDebugModeFailureMessage: {
    en: `Failed to send logs. Please try again later.`,
    "en-GB": `Failed to send logs. Please try again later.`,
    "ms-MY": `Gagal menghantar log. Sila cuba lagi kemudian.`,
    "th-TH": `ไม่สามารถส่งบันทึกได้ โปรดลองอีกครั้งในภายหลัง.`,
    "vi-VN": `Không thể gửi log. Vui lòng thử lại sau.`,
    "id-ID": `Gagal mengirim log. Silakan coba lagi nanti.`,
    "zh-CN": `无法发送日志。请稍后再试。`
  },
  AboutToEnterDebugMode: {
    en: `You are about to enter debug mode.`,
    "en-GB": `You are about to enter debug mode.`,
    "ms-MY": `Anda akan memasuki mod debug.`,
    "th-TH": `คุณกำลังจะเข้าสู่โหมดดีบัก.`,
    "vi-VN": `Bạn sắp vào chế độ debug.`,
    "id-ID": `Anda akan masuk mode debug.`,
    "zh-CN": `您即将进入调试模式。`
  },
  EnterDebugMode: {
    en: `Enter debug mode`,
    "en-GB": `Enter debug mode`,
    "ms-MY": `Masuk mod debug`,
    "th-TH": `เข้าสู่โหมดดีบัก`,
    "vi-VN": `Vào chế độ debug`,
    "id-ID": `Masuk mode debug`,
    "zh-CN": `进入调试模式`
  },
  AuthorizationMessage: {
    en: `To facilitate debugging, we will record your interactions with our page once you enter debug mode. Any sensitive data will be censored before recording. These recorded logs will only be used to improve your experience on our platform and will not be shared with any third party. You will be able to exit debug mode at any time. 
    These are the additional tracking points that we will be recording during debug mode:
    

 1. HTML DOM Tree Update Events
    
 2. Mouse Movement Events
    
 3. Console Events
    
 4. Network Events
    
 5. Keyboard Events (Excluding any keyboard events used in data entry)`,
    "en-GB": `To facilitate debugging, we will record your interactions with our page once you enter debug mode. Any sensitive data will be censored before recording. These recorded logs will only be used to improve your experience on our platform and will not be shared with any third party. You will be able to exit debug mode at any time. 
    These are the additional tracking points that we will be recording during debug mode:
    

 1. HTML DOM Tree Update Events
    
 2. Mouse Movement Events
    
 3. Console Events
    
 4. Network Events
    
 5. Keyboard Events (Excluding any keyboard events used in data entry)`,
    "ms-MY": `Untuk memudahkan penyelesaian masalah, kami akan merakam interaksi anda dengan laman kami sebaik sahaja anda memasuki mod debug. Sebarang data sensitif akan disensor sebelum dirakam. Log yang dirakam ini hanya akan digunakan untuk meningkatkan pengalaman anda di platform kami dan tidak akan dikongsi dengan mana-mana pihak ketiga. Anda boleh keluar dari mod debug pada bila-bila masa.
    Berikut adalah titik-titik penjejakan tambahan yang akan kami rakam semasa mod debug:
    

 1. Acara Kemas Kini Pohon DOM HTML
    
 2. Acara Gerakan Tetikus
    
 3. Acara Konsol
    
 4. Acara Jaringan
    
 5. Acara Papan Kekunci (Kecuali sebarang acara papan kekunci yang digunakan dalam entri data)`,
    "th-TH": `เพื่อทำให้การแก้ไขข้อผิดพลาดง่ายขึ้น, เราจะบันทึกการโต้ตอบของคุณกับหน้าของเราเมื่อคุณเข้าสู่โหมดดีบัก ข้อมูลที่ละเอียดอ่อนใด ๆ จะถูกเซ็นเซอร์ก่อนการบันทึก บันทึกที่ได้รับการบันทึกเหล่านี้จะถูกใช้เพื่อปรับปรุงประสบการณ์ของคุณบนแพลตฟอร์มของเราเท่านั้นและจะไม่แชร์กับบุคคลที่สาม คุณจะสามารถออกจากโหมดดีบักได้ทุกเวลา
    นี่คือจุดติดตามเพิ่มเติมที่เราจะบันทึกระหว่างโหมดดีบัก:
    

 1. เหตุการณ์การอัปเดตต้นไม้ DOM ของ HTML
    
 2. เหตุการณ์การเคลื่อนที่ของเมาส์
    
 3. เหตุการณ์คอนโซล
    
 4. เหตุการณ์เครือข่าย
    
 5. เหตุการณ์การใช้คีย์บอร์ด (ไม่รวมเหตุการณ์การใช้คีย์บอร์ดใด ๆ ที่ใช้ในการป้อนข้อมูล)`,
    "vi-VN": `Để tạo thuận lợi cho việc gỡ lỗi, chúng tôi sẽ ghi lại các tương tác của bạn với trang của chúng tôi ngay khi bạn bước vào chế độ debug. Bất kỳ dữ liệu nhạy cảm nào sẽ được kiểm duyệt trước khi ghi. Những nhật ký được ghi lại chỉ được sử dụng để cải thiện trải nghiệm của bạn trên nền tảng của chúng tôi và sẽ không được chia sẻ với bất kỳ bên thứ ba nào. Bạn sẽ có thể thoát khỏi chế độ debug bất kỳ lúc nào.
    Dưới đây là các điểm theo dõi bổ sung mà chúng tôi sẽ ghi lại trong chế độ debug:
    

 1. Sự kiện Cập nhật Cây DOM HTML
    
 2. Sự kiện Di chuyển chuột
    
 3. Sự kiện Console
    
 4. Sự kiện Mạng
    
 5. Sự kiện Bàn phím (Trừ bất kỳ sự kiện bàn phím nào được sử dụng trong nhập dữ liệu)`,
    "id-ID": `Untuk memudahkan penyelesaian masalah, kami akan merekam interaksi Anda dengan halaman kami begitu Anda masuk ke mode debug. Semua data sensitif akan disensor sebelum direkam. Data yang direkam ini hanya akan digunakan untuk meningkatkan pengalaman Anda di platform kami dan tidak akan dibagikan dengan pihak ketiga mana pun. Anda dapat keluar dari mode debug kapan saja.
    Berikut adalah titik pelacakan tambahan yang akan kami rekam selama mode debug:
    

 1. Pembaruan Pohon DOM HTML
    
 2. Gerakan Mouse
    
 3. Konsol
    
 4. Jaringan
    
 5. Keyboard (Mengecualikan event keyboard apa pun yang digunakan dalam entri data)`,
    "zh-CN": `为了方便调试，一旦您进入调试模式，我们将记录您与我们页面的交互。在记录之前，任何敏感数据都将被脱敏。这些记录的日志仅用于改善您在我们平台上的体验，不会与任何第三方共享。您可以随时退出调试模式。
    以下是我们在调试模式期间将记录的附加跟踪点：
    

 1. HTML DOM 树更新事件
    
 2. 鼠标移动事件
    
 3. 控制台事件
    
 4. 网络事件
    
 5. 键盘事件（不包括用于数据输入的任何键盘事件）`
  },
  UserResearchAuthorisationTitle: {
    en: `Let's grow together! Your insights shapes our platform.`,
    "en-GB": `Let's grow together! Your insights shapes our platform.`,
    "ms-MY": `Marilah kita berkembang bersama! Pandangan anda membentuk platform kami.`,
    "th-TH": `มาเติบโตไปด้วยกัน! ความคิดเห็นของคุณช่วยสร้างแพลตฟอร์มของเรา.`,
    "vi-VN": `Hãy cùng nhau phát triển! Ý kiến của bạn định hình nền tảng của chúng tôi.`,
    "id-ID": `Mari tumbuh bersama! Wawasan Anda membentuk platform kami.`,
    "zh-CN": `让我们一起成长！您的见解塑造了我们的平台。`
  },
  UserResearchAuthorisationMessage: {
    en: `To enhance your experience on our platform, we'd like to send additional logs.     Safeguarding your privacy remains our priority - rest assured that any sensitive information     will be redacted. These logs solely serve to improve our platform and won't be     shared with third parties. The additional events are:     HTML DOM Tree Update Events, Mouse Movement Events, Console Events, Network Events and Keyboard     Events (Excluding any keyboard events used in data entry).`,
    "en-GB": `To enhance your experience on our platform, we'd like to send additional logs.     Safeguarding your privacy remains our priority - rest assured that any sensitive information     will be redacted. These logs solely serve to improve our platform and won't be     shared with third parties. The additional events are:     HTML DOM Tree Update Events, Mouse Movement Events, Console Events, Network Events and Keyboard     Events (Excluding any keyboard events used in data entry).`,
    "ms-MY": `Untuk memperbaiki pengalaman anda di platform kami, kami ingin menghantar log tambahan.     Melindungi privasi anda tetap menjadi keutamaan kami - yakinlah bahawa sebarang maklumat sensitif     akan diserap. Log ini hanya bertujuan untuk meningkatkan platform kami dan tidak akan     dikongsi dengan pihak ketiga. Acara tambahan adalah: Acara Kemas Kini Pohon DOM HTML, Acara Gerakan Tetikus,     Acara Konsol, Acara Jaringan, Acara Papan Kekunci (Kecuali sebarang acara papan kekunci     yang digunakan dalam entri data).`,
    "th-TH": `เพื่อเพิ่มประสบการณ์ในการใช้งานบนแพลตฟอร์มของเรา เราต้องการส่งบันทึกข้อมูลเพิ่มเติมไปให้คุณ     การคุ้มครองความเป็นส่วนตัวของคุณยังคงเป็นสิ่งที่เราให้ความสำคัญ - โปรดมั่นใจว่าข้อมูลที่ละเอียดอ่อนใด ๆ     จะถูกลบทิ้ง บันทึกเหล่านี้มีจุดประสงค์เพื่อปรับปรุงแพลตฟอร์มของเราและจะไม่     ถูกแชร์กับบุคคลที่สาม กิจกรรมที่เพิ่มเติมซึ่งจะถูกรวมเข้าไปในบันทึกนี้ ได้แก่ กิจกรรมการอัปเดต HTML DOM Tree, 
    กิจกรรมการเคลื่อนไหวของเมาส์, กิจกรรมของ Console, กิจกรรม Network และ กิจกรรมของคีย์บอร์ด     (ยกเว้นกิจกรรมคีย์บอร์ดที่ถูกใช้สำหรับการป้อนข้อมูล).`,
    "vi-VN": `Để nâng cao trải nghiệm của bạn trên nền tảng của chúng tôi, chúng tôi muốn gửi thêm các bản ghi.     Bảo vệ quyền riêng tư của bạn vẫn là ưu tiên hàng đầu của chúng tôi - hãy yên tâm rằng bất kỳ thông tin nhạy cảm nào     sẽ bị mờ đi. Những bản ghi này chỉ phục vụ để cải thiện nền tảng của chúng tôi và sẽ không     được chia sẻ với bên thứ ba. Các sự kiện bổ sung là: Sự kiện Cập nhật Cây DOM HTML, Sự kiện Di chuyển chuột, Sự kiện Console, Sự kiện Mạng, Sự kiện Bàn phím     (Trừ bất kỳ sự kiện bàn phím nào được sử dụng trong nhập dữ liệu).`,
    "id-ID": `Untuk meningkatkan pengalaman Anda di platform kami, kami ingin mengirim log tambahan.     Melindungi privasi Anda tetap menjadi prioritas kami - yakinlah bahwa informasi sensitif apa pun     akan dihapus. Log ini hanya berfungsi untuk meningkatkan platform kami dan tidak akan     dibagikan dengan pihak ketiga. Acara tambahan adalah: Pembaruan Pohon DOM HTML, Gerakan Mouse, Konsol, Jaringan, Keyboard     (Mengecualikan event keyboard apa pun yang digunakan dalam entri data).`,
    "zh-CN": `为了增强您在我们平台上的体验，我们希望发送额外的日志。     保护您的隐私仍然是我们的首要任务 - 请放心，任何敏感信息     在记录之前都将被删除。这些记录的日志仅用于改进我们的平台，不会     与任何第三方共享。额外的事件包括：HTML DOM 树更新事件，鼠标移动事件，控制台事件，网络事件和键盘     事件（不包括用于数据输入的任何键盘事件）。`
  },
  AcceptAuthorisation: {
    en: `Accept`,
    "en-GB": `Accept`,
    "ms-MY": `Terima`,
    "th-TH": `ยอมรับ`,
    "vi-VN": `Chấp nhận`,
    "id-ID": `Terima`,
    "zh-CN": `接受`
  },
  DeclineAuthorisation: {
    en: `Decline`,
    "en-GB": `Decline`,
    "ms-MY": `Tolak`,
    "th-TH": `ปฏิเสธ`,
    "vi-VN": `Từ chối`,
    "id-ID": `Tolak`,
    "zh-CN": `拒绝`
  }
};
export {
  LocalTranslation
};
